'use client'

import { useRouter } from 'next/navigation'
import { Button } from '@mantine/core'

export default function ClientSideBackButton() {
  const router = useRouter()
  const handleBack = () => router.back()

  return (
    <Button w="200px" ta="center" onClick={handleBack} variant="link" color="gray">
      Back
    </Button>
  )
}
